import React from 'react';
import { LEARN_CONTENT } from './LearnContent';
import { ArrowRight } from 'lucide-react';

export default function LearnHub({ onArticleClick, onBack }) {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <button onClick={onBack} style={styles.backBtn}>← Back to Home</button>
        <h1 style={styles.title}>Learn & Mastery</h1>
        <div style={styles.introBox}>
          <p style={styles.introText}>
            A curated knowledge base built for serious traders. No recycled blog content. No generic advice. 
            Only practical guides focused on discipline, risk control, and long-term consistency.
          </p>
        </div>
      </header>

      <div style={styles.grid}>
        {LEARN_CONTENT.map((article) => (
          <div key={article.slug} style={styles.card} onClick={() => onArticleClick(article)}>
            <div style={{...styles.category, color: article.accent, borderColor: article.accent}}>
              {article.category}
            </div>
            <h3 style={styles.cardTitle}>{article.title}</h3>
            <p style={styles.cardDesc}>{article.description}</p>
            <div style={{...styles.readMore, color: article.accent}}>
              Read Guide <ArrowRight size={16} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#000', padding: '60px 20px', color: '#fff' },
  header: { maxWidth: '1000px', margin: '0 auto 60px auto', textAlign: 'center' },
  backBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', marginBottom: '20px', fontWeight: '600' },
  title: { fontSize: '42px', fontWeight: '900', marginBottom: '20px', letterSpacing: '-1.5px' },
  introBox: { maxWidth: '700px', margin: '0 auto', borderTop: '1px solid #1e293b', paddingTop: '20px' },
  introText: { color: '#94a3b8', fontSize: '16px', lineHeight: '1.6', fontStyle: 'italic' },
  grid: { maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' },
  card: { background: '#0d1117', padding: '30px', borderRadius: '20px', border: '1px solid #1e293b', cursor: 'pointer', transition: '0.2s' },
  category: { display: 'inline-block', padding: '4px 10px', borderRadius: '6px', fontSize: '10px', fontWeight: '800', border: '1px solid', marginBottom: '16px', textTransform: 'uppercase' },
  cardTitle: { fontSize: '22px', fontWeight: '800', marginBottom: '12px' },
  cardDesc: { color: '#94a3b8', fontSize: '14px', lineHeight: '1.6', marginBottom: '20px' },
  readMore: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: '700' }
};